/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { SIDE_NAV_WIDTH_SESSION_STORAGE_KEY } from "constants/constants";
import { getRhpWidth } from "selectors/skinnyRailSelectors";

export const getExpandedPanelWidth = stores => {
  try {
    const sideNavWidthInSS = sessionStorage.getItem(SIDE_NAV_WIDTH_SESSION_STORAGE_KEY);
    if (sideNavWidthInSS) {
      return Number(sideNavWidthInSS);
    }
  } catch (err) {
    // Do nothing
  }
  return getRhpWidth(stores);
};
